import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth-service';
import { environment } from '../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import {
  CancellationReasonsResponse,
  OrderByType,
  OrderDirType,
} from '../../pages/admin-dashboard/cancellation-reasons/cancellationReason.model';
import {
  CancellationReason,
  CancellationReasonDTO,
  CancellationReasonError,
} from '../../pages/admin-dashboard/cancellation-reasons/cancellationReason.model';

@Injectable({
  providedIn: 'root',
})
export class CancellationReasons {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private API = environment.pharmacyMgtApiUrl;
  private readonly cancellationReasonsUrl = `${this.API}/orders/cancellation/reasons`;

  getAllCancellationReasons(
    lang: 'ar' | 'en',
    paramsIn?: {
      quickSearch?: string;
      pageNum?: number;
      pageSize?: number;
      orderBy?: OrderByType;
      orderDir?: OrderDirType;
      createdOnFrom?: string;
      createdOnTo?: string;
      lastModifiedOnFrom?: string;
      lastModifiedOnTo?: string;
    },
  ) {
    let params = new HttpParams();

    if (paramsIn) {
      if (paramsIn.quickSearch) params = params.set('quickSearch', paramsIn.quickSearch);
      if (paramsIn.pageNum !== undefined) params = params.set('pageNum', paramsIn.pageNum.toString());
      if (paramsIn.pageSize !== undefined) params = params.set('pageSize', paramsIn.pageSize.toString());
      if (paramsIn.orderBy) params = params.set('orderBy', paramsIn.orderBy);
      if (paramsIn.orderDir) params = params.set('orderDir', paramsIn.orderDir);
      if (paramsIn.createdOnFrom) params = params.set('createdOnFrom', paramsIn.createdOnFrom);
      if (paramsIn.createdOnTo) params = params.set('createdOnTo', paramsIn.createdOnTo);
      if (paramsIn.lastModifiedOnFrom) params = params.set('lastModifiedOnFrom', paramsIn.lastModifiedOnFrom);
      if (paramsIn.lastModifiedOnTo) params = params.set('lastModifiedOnTo', paramsIn.lastModifiedOnTo);
    }

    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    headers = headers.set('Accept-Language', lang);
    return this.http.get<CancellationReasonsResponse>(this.cancellationReasonsUrl, { params, headers }).pipe(
      // tap(() =>
      // console.log('Cancellation reasons retrieved successfully',params),),
      catchError(this.handleError),
    );
  }
  private handleError(error: any) {
    return throwError(() => error);
  }

  createCancellationReason(dto: CancellationReasonDTO) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.post<CancellationReason>(this.cancellationReasonsUrl, dto, { headers }).pipe(
      // tap(() => {
      //   console.log('Cancellation reason created successfully');
      // }),
      catchError(this.handleErrorCreate),
    );
  }
  
  deleteCancellationReason(reasonId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.delete<void>(`${this.cancellationReasonsUrl}/${reasonId}`, { headers }).pipe(
      tap(() => console.log('reason deleted successfully')),
      catchError(this.handleErrorCreate),
    );
  }

  updateCancellationReason(reasonId: number, dto: CancellationReasonDTO) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.put<void>(`${this.cancellationReasonsUrl}/${reasonId}`, dto, { headers }).pipe(
      // tap(() => {
      //   console.log('Cancellation reason edited successfully');
      // }),
      catchError(this.handleErrorCreate),
    );
  }

  private handleErrorCreate(error: HttpErrorResponse) {
    const apiError: CancellationReasonError = error.error;
    // console.error('Cancellation reason API error:', apiError);
    return throwError(() => apiError);
  }
}
